module.exports = __webpack_public_path__ + "static/img/txt.dcd6e141.png";